import React from "react";
import {
    CSidebar,
    CSidebarNav,
    CNavItem,
  } from '@coreui/react'
  
  import CIcon from '@coreui/icons-react'
  import { cilList, cilCalendarCheck, cilPeople, cilLayers, cilSpeedometer } from '@coreui/icons'
  

function SideBar () {


    
    return(
        <div className="sideBar">
            <ul className="sideBar-list">
           
                    <CSidebar visible={true} className="border-end ">
                    <CSidebarNav>
                      <CNavItem href="/shelter-dashboard">
                        <CIcon customClassName="nav-icon" icon={cilSpeedometer} /> Dashboard
                      </CNavItem>
                      <CNavItem href="/shelter-pet-list">
                        <CIcon customClassName="nav-icon" icon={cilList} /> Pet List
                      </CNavItem>
                      <CNavItem href="/shelter-application-list">
                        <CIcon customClassName="nav-icon" icon={cilPeople} /> Application List
                      </CNavItem>
                      <CNavItem href="/shelter-appointment-list">
                        <CIcon customClassName="nav-icon" icon={cilCalendarCheck} /> Appointment List
                      </CNavItem>
                      <CNavItem href="/shelter-final-approval">
                        <CIcon customClassName="nav-icon" icon={cilLayers} /> Final Approval
                      </CNavItem>
                    </CSidebarNav>
                    
                  </CSidebar>

            </ul>
        </div>
    );

}


export default SideBar;
